import { ReactNode } from "react";
import { Card } from "antd";

import styles from "./StatsTotalItem.module.scss";
import { StatsItemSkeleton } from "../stats-item-skeleton";

interface StatsTotalItemProps {
  loading?: boolean;
  icon: ReactNode;
  primaryNumber: number;
}

export const StatsTotalItem = ({
  loading,
  icon,
  primaryNumber,
}: StatsTotalItemProps) => {
  if (loading) {
    return <StatsItemSkeleton />;
  }

  return (
    <Card className={styles.card}>
      <div className={styles.container}>
        {icon}
        <div className={styles.total}>
          <span className={styles.label}>Tổng yêu cầu:</span>
          {primaryNumber}
        </div>
      </div>
    </Card>
  );
};
